export default __webpack_public_path__ + "img/icons.63e68c6d1fdaf6780de262aeb8f4cb1b.svg";